import React from 'react';
import Card from '../../../components/Card';
import TextInput from '../../../components/TextInput';
import styles from './AddressInformations.module.sass';

const AddressInformations = ({ company, onCompanyChange }) => {
  return (
    <Card className={styles.card} title="Adresse de l'entreprise" classTitle="title-green">

      <div className={styles.group}>

        <TextInput
          className={styles.field}
          label="Adresse"
          name="address"
          type="text"
          placeholder="Adresse complète"
          value={company?.address || ''}
          onChange={onCompanyChange}
        />
        <TextInput
          className={styles.field}
          label="Complément d'adresse"
          name="address_complement"
          type="text"
          placeholder="Ex: Appartement, étage..."
          value={company?.address_complement || ''}
          onChange={onCompanyChange}
        />
        <TextInput
          className={styles.field}
          label="Code Postal"
          name="zip_code"
          type="text"
          placeholder="Code postal"
          value={company?.zip_code || ''}
          onChange={onCompanyChange}
        />
        <TextInput
          className={styles.field}
          label="Ville"
          name="city"
          type="text"
          placeholder="Ville"
          value={company?.city || ''}
          onChange={onCompanyChange}
        />
        <TextInput
          className={styles.field}
          label="Pays"
          name="country"
          type="text"
          placeholder="Pays"
          value={company?.country || ''}
          onChange={onCompanyChange}
        />
      </div>
    </Card >
  );
};

export default AddressInformations;
